import { render, staticRenderFns } from "./LoginFormDeactivated.vue?vue&type=template&id=11282097&scoped=true"
import script from "./LoginFormDeactivated.vue?vue&type=script&lang=js"
export * from "./LoginFormDeactivated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11282097",
  null
  
)

export default component.exports